import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Notion = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#ffffff"
      d="M2.2,2.2l9.9-0.8c1.2-0.1,1.5,0,2.3,0.5l3.2,2.3c0.5,0.4,0.7,0.5,0.7,0.9V18c0,0.8-0.3,1.3-1.3,1.3L5.5,20.1
	c-0.7,0-1.1-0.1-1.5-0.6l-2.3-3.2c-0.4-0.6-0.6-1-0.6-1.5V3.5C1.2,2.8,1.4,2.3,2.2,2.2z"
    />
    <path
      fill="hsl(from hsl(0 0% 9%) h s 50%)"
      d="M14.9,2.4L4.3,3.2C3.5,3.3,3.2,3.9,3.2,4.6v12.1c0,0.5,0.2,1,0.6,1.6l2.5,3.4c0.4,0.5,0.8,0.7,1.6,0.6l12.3-0.8
	c1-0.1,1.3-0.6,1.3-1.4V6.5c0-0.4-0.2-0.6-0.7-0.9L17.4,3C16.6,2.4,16.2,2.3,14.9,2.4L14.9,2.4z M8.1,6.3c-1,0.1-1.2,0.1-1.8-0.4
	L4.9,4.7C4.7,4.5,4.8,4.3,5.2,4.3l10.2-0.8C16.2,3.4,16.7,3.8,17,4l1.8,1.3c0.1,0,0.3,0.3,0,0.3L8.3,6.3L8.1,6.3L8.1,6.3z M7,20.1
	V8.5C7,8,7.1,7.7,7.6,7.7l12.1-0.7c0.4,0,0.6,0.2,0.6,0.7v11.5c0,0.5-0.1,0.9-0.7,1L7.9,20.9C7.3,20.9,7,20.7,7,20.1L7,20.1z
	 M18.4,9.1c0.1,0.4,0,0.7-0.3,0.7l-0.6,0.1v8.6c-0.5,0.3-0.9,0.4-1.3,0.4c-0.6,0-0.7-0.2-1.2-0.8l-3.7-6V18l1.2,0.3
	c0,0,0,0.7-0.9,0.7L9,19.1c-0.1-0.2,0-0.5,0.3-0.6l0.7-0.2v-7.7L9,10.5c-0.1-0.4,0.1-0.9,0.6-0.9l2.8-0.2l3.8,6.1v-5.4l-1-0.1
	c-0.1-0.4,0.2-0.7,0.6-0.8L18.4,9.1L18.4,9.1z"
    />
  </svg>
);
